import { AccountInfo } from '@azure/msal-browser';
import axios, { AxiosError } from 'axios';

import { envConfig } from '../../../config';
import publicClientApplication from '../../authentication/components/config/auth.config';
import { LocalStorageProperties } from '../enums/local-storage-properties.enum';
import localStorageService from '../services/local-storage/local-storage.service';
import { updateLocalStorageInformation } from '../utils/update-local-storage-information/update-local-storage-information.util';

export const axiosInstance = axios.create({
  baseURL: envConfig.api.baseUrl,
});

axiosInstance.interceptors.request.use(
  async function (config) {
    if (config.omitAuthHeader) {
      return config;
    }
    const token: string | null = localStorageService.get(
      LocalStorageProperties.ID_TOKEN
    ) as string | null;
    const tokenType: string | null = localStorageService.get(
      LocalStorageProperties.TOKEN_TYPE
    ) as string | null;
    if (token && tokenType) {
      return {
        ...config,
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
      };
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error: AxiosError) {
    if (error.response?.data?.apierror?.message) {
      error.message = error.response.data.apierror.message;
    }

    error.code = error.response?.status.toString();

    if (error.response?.status !== 401) {
      return Promise.reject(error);
    }

    const userAccountInfo = localStorageService.get(
      LocalStorageProperties.ACCOUNT_INFO
    ) as AccountInfo;

    try {
      const result = await publicClientApplication.acquireTokenSilent({
        scopes: ['user.read'],
        account: userAccountInfo,
      });

      updateLocalStorageInformation(result);

      return axiosInstance.request(error.config);
    } catch (err) {
      console.warn(err);
      await publicClientApplication.logoutRedirect({
        account: userAccountInfo,
      });
      return Promise.reject(error);
    }
  }
);
